import React from "react";
import { Oval } from "react-loader-spinner";

function BlueButton({ title, onButtonClicked, isLoading, disabled, testId }) {
  const onClicked = (e) => {
    if (isLoading || disabled) return;
    onButtonClicked();
  };

  return (
    <div
      onClick={onClicked}
      data-testid={testId}
      className={`w-[296px] h-[30px] bg-blueColor rounded-[6px] flex items-center justify-center ${
        disabled ? "opacity-50 cursor-not-allowed" : isLoading ? "cursor-not-allowed" : "cursor-pointer"
      }`}
    >
      {isLoading ? (
        <Oval
          visible={true}
          height="16"
          width="16"
          color="#FFFFFF"
          strokeWidth={8}
          secondaryColor="#FFEEFF"
          ariaLabel="oval-loading"
        />
      ) : (
        <span className="text-white text-[10px] text-OpenSansRegular font-[600]">{title}</span>
      )}
    </div>
  );
}

export default BlueButton;
